// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"348":"c1d96569","2554":"de2b2409","9325":"de2b2409"}[chunkId] + ".chunk.css";
};